class Search {

    searchFileds = null
    data = null
    value = null
    acronimse = null
    acronimseType = null
    extraSearch = null
    array = null
    string = false

    constructor (inputFileds, data, value, acronimse, string, stringNumber) {
        this.searchFileds = inputFileds
        this.data = data
        this.value = value
        this.acronimse = acronimse
        this.array = []
        this.string = string
        this.extraSearch = stringNumber
    }

    async search () {
        this.data.forEach( element => {
            if (this.searchSection(element)) {
                this.array.push(element)
            }
        })
        return this.array
    }

    searchSection (element) {
        if (!this.string){
            for (let index = 0 ; index < this.searchFileds.length ; index++) {
                if (this.value === element[this.acronimse[this.searchFileds[index]]]) {
                    return true
                }
            }
        } else {
            for (let index = 0 ; index < this.searchFileds.length ; index++) {
                if (element[this.acronimse[this.searchFileds[index]]] !== null && (this.value.toLowerCase() === element[this.acronimse[this.searchFileds[index]]].toLowerCase() || element[this.acronimse[this.searchFileds[index]]].toLowerCase().includes(this.value.toLowerCase()))) {
                    return true
                }
            }
        }

        if (this.extraSearch !== null && this.extraSearch.length > 0) {
            if (!this.string) {
                this.value = `${this.value}`
            }
            for (let index = 0 ; index < this.extraSearch.length ; index++){
                if (element[this.acronimse[this.extraSearch[index]]].toLowerCase().includes(this.value.toLowerCase()) || element[this.acronimse[this.extraSearch[index]]].toLowerCase() === this.value.toLowerCase()) {
                    return true
                }
            }
        }

        return false
    }
    
}

export default Search
